import type {
  CreateDivisionRequestDto,
  DivisionDto,
  GetDivisionsResponseDto,
  RemoveDivisionResponseDto,
  UpdateDivisionRequestDto,
} from 'shared/dtos/divisions.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import DivisionsService from 'services/divisions.service';
import { MODAL_DIVISION } from 'shared/constants/modals';
import { closeModal } from 'store/modals/modals.slice';

const divisionsService = new DivisionsService();

export const getDivisionsThunk = createAsyncThunk<GetDivisionsResponseDto>(
  'divisions/getDivisions',
  async (_, thunkAPI) => {
    try {
      const result = await divisionsService.getDivisions();
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getDivisionThunk = createAsyncThunk<DivisionDto, number>(
  'divisions/getDivision',
  async (id, thunkAPI) => {
    try {
      const result = await divisionsService.getDivision(id);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createDivisionThunk = createAsyncThunk<
  DivisionDto,
  CreateDivisionRequestDto
>(
  'divisions/createDivision',
  async (formData: CreateDivisionRequestDto, thunkAPI) => {
    try {
      const result = await divisionsService.createDivision(formData);
      thunkAPI.dispatch(closeModal({ name: MODAL_DIVISION }));
      thunkAPI.dispatch(getDivisionsThunk());
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateDivisionThunk = createAsyncThunk<
  DivisionDto,
  UpdateDivisionRequestDto
>('divisions/updateDivision', async (payload, thunkAPI) => {
  try {
    const result = await divisionsService.updateDivision(payload.id, payload);

    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const removeDivisionThunk = createAsyncThunk<
  RemoveDivisionResponseDto,
  number
>('divisions/removeDivision', async (id, thunkAPI) => {
  try {
    const result = await divisionsService.removeDivision(id);
    thunkAPI.dispatch(getDivisionsThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
